
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/funds",
      function () {
        return require("private-next-pages/funds/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/funds"])
      });
    }
  